import { Typography } from '@shinetools/lumen-react'
import { colors } from '@shinetools/lumen-tokens/web/colors'
import { useTranslation } from 'react-i18next'

import { MastercardSymbol } from '../../../../assets/images'
import * as Styled from './styles'

export const MastercardTrustNote = () => {
  const { t } = useTranslation()

  return (
    <Styled.Note>
      <Styled.Logo aria-hidden>
        <MastercardSymbol />
      </Styled.Logo>
      <Typography.Text color={colors.content.neutral.medium} size="small">
        {t('bankreconciliation.connect_bank.mastercard_trust_note')}
      </Typography.Text>
    </Styled.Note>
  )
}
